import React, { useRef, useState, useEffect } from "react"
import Container from "@structure/Container"
import { useLockScroll } from "@utils/LockScroll"
import { InitLoadHook } from "@utils/GetInitLoad"
import BtnPlus from "@images/shared/isi-plus-btn.inline.svg"
import BtnMinus from "@images/shared/isi-minus-btn.inline.svg"

import tw, { css } from "twin.macro"
import { ISIContent } from "./IsiContent"

const IsiSticky = ({
  headerRef,
  hide,
  location,
  scrollTo,
  stickyIsiMaxHeight,
  setStickyIsiMaxHeight,
}) => {
  const [transitioned, setTransitioned] = useState(false)
  const [isiMaxHeight, setIsiMaxHeight] = useState(0)

  const [isExpanded, setIsExpanded] = useState(false)
  const isiHeaderRef = useRef(null)
  const [isiHeaderHeight, setIsiHeaderHeight] = useState(0)

  const { lockScroll, unlockScroll } = useLockScroll()

  const ref = useRef(null)

  const [screenshotMode, setScreenshotMode] = useState(false)
  const [screenshotState, setScreenshotState] = useState("")

  const initLoad = InitLoadHook()

  useEffect(() => {
    if (location?.search.includes("ed=1")) {
      setScreenshotMode(true)
      if (location?.search.includes("isiInitial=1")) {
        setScreenshotState("initial")
      } else if (location?.search.includes("isiCollapsed=1")) {
        setScreenshotState("collapsed")
      } else if (location?.search.includes("isiExpanded=1")) {
        setScreenshotState("expanded")
      }
    }
  }, [location?.search])

  useEffect(() => {
    // setMaxHeight
    const setMaxHeight = () => {
      const headerBottom =
        headerRef.current.getBoundingClientRect().bottom || 138
      const availableHeight =
        window.innerHeight - (headerBottom > 0 ? headerBottom + 20 : 20)
      const contentHeight = ref.current?.offsetHeight + 2
      // alert(headerRef.current.getBoundingClientRect().bottom)

        setIsiMaxHeight(
          contentHeight > availableHeight
            ? contentHeight - (contentHeight - availableHeight)
            : contentHeight
        )

    }

    window.addEventListener("resize", setMaxHeight)

    setMaxHeight()
    return () => {
      window.removeEventListener("resize", setMaxHeight)
    }
  }, [headerRef])

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  useEffect(() => {

    const checkForLandscape = () => {
      if (typeof window !== "undefined") {
        if(window.innerHeight > 500) {
        setStickyIsiMaxHeight(
          document.querySelector('[data-id="sticky-isi-contraindications"]').offsetHeight +
            document.querySelector('[data-id="sticky-isi-header"]').offsetHeight + 10
        )
      } else {
        setStickyIsiMaxHeight(55);
      }
      }
    }
    checkForLandscape();

    window.addEventListener("resize", checkForLandscape)
   
  }, [setStickyIsiMaxHeight])

  useEffect(() => {
    if (isExpanded) {
      lockScroll()
    } else {
      unlockScroll()
      setTransitioned(false)
    }
  }, [isExpanded, lockScroll, unlockScroll])

  const [scrollingPositions, setScrollingPositions] = useState({})

  useEffect(() => {
    if (isiHeaderRef.current) {
      setIsiHeaderHeight(isiHeaderRef.current.offsetHeight)
    }
    setScrollingPositions({
      contraindications: 0,
      warnings:
        document.querySelector('[data-id="sticky-isi-warnings"]').offsetTop -
        isiHeaderHeight,
      adverse:
        document.querySelector('[data-id="sticky-isi-adverse"]').offsetTop -
        isiHeaderHeight,
    })
  }, [scrollTo, setIsiHeaderHeight, isiHeaderHeight])

  //screenshot styles
  const screenshotStyles = [
    screenshotState === "initial" &&
      tw`h-[12.5rem] top-[43.5rem] lg:(h-[12.5rem] top-[48.3rem])`,
    screenshotState === "collapsed" &&
      tw`h-[9rem] top-[47rem] lg:(h-[4rem] top-[52.3rem])`,
    screenshotState === "expanded" &&
      tw`h-[63rem] top-[7px] lg:(h-[40rem] top-[17rem])`,
  ]

  return (
    <>
      <div
        data-id="isi-overlay"
        aria-hidden="true"
        onClick={toggleExpanded}
        css={[
          tw`fixed inset-0 bg-purple opacity-0 z-20 invisible transition-all duration-700 cursor-pointer`,
          isExpanded && tw`visible opacity-40`,
        ]}
      ></div>
      <aside
        aria-hidden="true"
        data-id="sticky-isi"
        css={[
          tw`overflow-hidden fixed w-full left-0 right-0 bottom-0 z-20 bg-purple text-tan mx-auto transform transition duration-700 rounded-t-2xl  border border-b-0 border-tan `,
          tw`translate-y-full`,
          tw`max-w-[calc(100vw-2rem)] lg:(pl-8) xl:max-w-[77.5rem]`,
          isExpanded && tw`z-30`,
          isExpanded &&
            css`
              right: var(--scrollbar-compensation);
            `,
          screenshotMode && screenshotStyles,
          initLoad && !hide && tw`-translate-y-0`,
          hide && tw`translate-y-full`,
        ]}
      >
        <button
          tw="absolute top-4 right-4 flex items-center z-20
        [svg > rect]:(transition-all duration-300) [svg > path]:(transition-all duration-300)
        hover:([svg > rect]:(fill-violet transition-all duration-300) [svg > path]:(stroke-tan transition-all duration-300))"
          onClick={toggleExpanded}
          aria-expanded={isExpanded}
          tabIndex={-1}
          data-id="sticky-isi-expand-btn"
        >
          <span tw="text-white text-sm font-extrabold mr-2 hidden md:(block)">
            {isExpanded || screenshotState === "expanded"
              ? "Collapse"
              : "Expand"}
          </span>
          {isExpanded || screenshotState === "expanded" ? (
            <BtnMinus />
          ) : (
            <BtnPlus />
          )}
        </button>

        <div data-id="isi-body" css={[transitioned && tw`overflow-auto`]}>
          <Container
            css={[
              tw`transition-all duration-1000 pr-12 pl-4 lg:(pr-0 gap-6 grid grid-cols-12)`,
              isExpanded
                ? [
                    css`
                      max-height: ${typeof window !== "undefined" &&
                      window.innerHeight - headerRef.current.offsetHeight}px;
                    `,
                    css`
                      @media (min-width: 1024px) {
                        max-height: ${isiMaxHeight}px;
                      }
                    `,
                  ]
                : [
                    tw`md:(max-h-[10rem]) `,
                    css`
                      @media (max-width: 1024px) {
                        max-height: ${stickyIsiMaxHeight}px;
                      }
                    `,
                  ],
            ]}
            onTransitionEnd={() => {
              isExpanded && setTransitioned(true)
            }}
          >
            <section
              css={[
                tw`pb-3 col-span-12 relative transition-[top] duration-500 sm:(pr-[4.5rem]) lg:(pr-[5.5rem])`,
                css`
                  top: -${scrollingPositions[scrollTo] || 0}px;
                `,
                isExpanded && tw`top-0`,
              ]}
              ref={ref}
            >
              <ISIContent
                stickyIsi={true}
                scrollTo={scrollTo}
                headerRef={isiHeaderRef}
              />
            </section>
          </Container>
        </div>
      </aside>
    </>
  )
}

export default IsiSticky
